<ng-container>
    <div class="grid-4col input-grid-gaps">
        <app-text-input
            [form]="form()"
            id="incomeInterestAccount"
            [prefix]="prefix"
        ></app-text-input>
        <app-text-input
            [form]="form()"
            id="incomePenaltyAccount"
            [prefix]="prefix"
        ></app-text-input>
        <app-text-input
            [form]="form()"
            id="receivableAccount"
            [prefix]="prefix"
        ></app-text-input>
        <app-text-input
            [form]="form()"
            id="expenceInterestAccount"
            [prefix]="prefix"
        ></app-text-input>
        <app-text-input
            [form]="form()"
            id="expencePenaltyAccount"
            [prefix]="prefix"
        ></app-text-input>
        <app-text-input
            [form]="form()"
            id="payableAccount"
            [prefix]="prefix"
        ></app-text-input>
    </div>
</ng-container>
